module.exports = "/_next/static/images/sa2-monotone-027883904f12cecb87b277b09e9862ed.svg";